import request from '../config/axiosConfig';
import { GET_LIST_QUIZ_ATTEMPTS } from '../constants/quizAttemptApiEndPoint';

export const getQuizAttempts = async (params) => {
  return (
    await request({
      url: GET_LIST_QUIZ_ATTEMPTS,
      method: 'GET',
      params,
    })
  )?.data;
};
